/**
 * The 404 component
 */
import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import Status from "./Status";
import Page from "../../components/Page";
import ProductSearch from "../../components/ProductSearch/ProductSearch";

const FourOFour = ({ staticContext = {} }) => {
  const [showSearchPreview, setShowSearchPreview] = useState(false);

  return (
    <Status code={404}>
      <Page
        id="404"
        title="Page not found"
        pageType="error"
        image="https://cdn.myfolie.de/media/banner/800x500.png"
      >
        <section>
          <ProductSearch
            searchType="not_found"
            attachedResults
            setShowSearchPreview={setShowSearchPreview}
            closeSearch={() => setShowSearchPreview(false)}
            showSearchPreview={showSearchPreview}
          />
        </section>
        <section className="my-3">
          <Container>
            <Row>
              <Col xs={12}>
                <h1>Oops, sorry!</h1>
                <p>The requested page was not found</p>
              </Col>
              <Col
                className="fourofour__container__cta"
                xs={{ size: 6, offset: 3 }}
                md={{ size: 4, offset: 4 }}
              >
                <Link to={`/`} className="btn btn-success">
                  Back to myfolie.com
                </Link>
              </Col>
            </Row>
          </Container>
        </section>
      </Page>
    </Status>
  );
};

export default FourOFour;
